export default {
    LOADING: Symbol('loading'),
    ERROR: Symbol('error'),
    LOADED: Symbol('loaded'),
    TIMEOUT: Symbol('timeout'),
}